const awaitBrowserGeolocation = () =>
    new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            position =>
                resolve({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                }),
            error => reject(error),
            {
                maximumAge: 30000,
                timeout: 5000,
            },
        );
    });

const updateGeolocationInput = geolocation => {
    const geolocationInput = document.querySelector('input[data-browser-geolocation]');
    if (!geolocationInput) return;
    geolocationInput.value = `${geolocation.latitude},${geolocation.longitude}`;
};

awaitBrowserGeolocation().then(updateGeolocationInput);
